<template>
    <div class="layout">
        <div id="search">
            <Input id="search-input" v-model="searchInput" style="display:inline-block;" type="text" placeholder="请输入"></Input>
            <br />
            <p id="search-p" style="display:inline-block;">输入Icon类名搜索，比如 success</p>
        </div>
        <div id="icon-box">
            <ul>
                <li style="float: left;margin:10px">
                    <Button type="dashed" title="添加图标" style="width:90px;height:90px;" @click="modalDisPlay = true">
                        <i class="iconfont icon-file-add" style="font-weight:300;font-size:40px"></i>
                    </Button>

                </li>

                <li class="icon-item" v-for="item in iconData">
                    <svg class="icon icon-item-dele" @click="deleIcon(item.id)">
                        <use xlink:href="#icon-delete"></use>
                    </svg>

                    <svg class="icon">
                        <use :xlink:href="item.iconClass" style="font-size: 30px;"></use>
                    </svg>
                    <!--<i :class="item.iconClass" style="font-weight:800;font-size:20px"></i>-->

                    <br />
                    <span>{{item.iconName}}</span>
                </li>
            </ul>
        </div>
        <div id="page-box">
            <Page :total="iconCount" :page-size="pageSize"
                  @on-change="pageChange" show-total
                  :current="pageIndex"
                  style="display:inline-block;">
            </Page>
        </div>
        <Modal v-model="modalDisPlay" draggable sticky scrollable>
            <p slot="header" style="text-align:left">
                <Icon type="ios-create-outline" size='18'/>
                <span> 添加图标</span>
            </p>
            <Form ref="formInline" :model="formItem" :label-width="100" :rules="ruleInline">
                <Form-item label="图标名" prop="iconName">
                    <Input v-model="formItem.iconName" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="图标类名" prop="iconClass">
                    <Input v-model="formItem.iconClass" placeholder="图标类名前需加上#"></Input>
                </Form-item>
            </Form>

            <div slot="footer">
                <Button size="large" @click="cancel('formInline')">取消</Button>
                <Button type="primary" size="large" @click="handleSubmit('formInline')">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import request from '@/utils/request'

    export default {
        name: 'iconmanage',
        data() {
            return {
                searchInput: '',
                iconData: [],
                iconCount: 0,
                pageSize: 69,
                pageIndex:1,
                modalDisPlay: false,
                formItem: {
                    iconName: '',
                    iconClass: '',
                    creator: parseInt(localStorage.getItem("userId"))
                },
                ruleInline: {
                    iconName: [
                        { required: true, message: '请填写图标名', trigger: 'blur' },
                        { type: 'string', max: 100, message: '输入不得大于100个字', trigger: 'blur' }
                    ],
                    iconClass: [
                        { required: true, message: '请填写图标类名', trigger: 'blur' },
                        { type: 'string', max: 100, message: '输入不得大于100个字', trigger: 'blur' }
                    ]
                }
            }
        },
        
        methods: {
            initIconData(pageIndex) {
                var data = {
                    'IconName': this.searchInput,
                    'PageSize': this.pageSize,
                    'PageIndex': pageIndex
                }
                let component = this;
                request.post('/api/IconLibrary/GetIconLibraryList', data).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: response.errorMsg
                        });
                        return;
                    }
                    component.iconData = response.data.iconLibraryVM;
                    component.iconCount = response.data.itemCount;

                }).catch(function (error) {
                })
                this.pageIndex = pageIndex;
            },
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let component = this;
                        request.post('/api/IconLibrary/AddIconLibrary', this.formItem).then(function (response) {

                            if (response.state == 0) {
                                component.$Notice.error({
                                    title: '错误提示',duration: 3,
                                    desc: "保存失败：" + response.errorMsg
                                });
                                return;
                            }

                            //清空form规则检查
                            component.$refs[name].resetFields();
                            component.modalDisPlay = false;
                            component.initIconData(1);
                            component.$Notice.success({
                                title: '正确提示',duration: 3,
                                desc: '保存成功!'
                            });

                        }).catch(function (error) {
                        })
                    }
                })
            },
            deleIcon(id) {
                let component = this;
                request.get('/api/IconLibrary/DeleIconLibrary', {
                    params: {
                        IconLibraryId: id
                    }
                }).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "删除失败：" + response.errorMsg
                        });
                        return;
                    }
                    component.initIconData(1);

                }).catch(function (error) {
                })
            },
            cancel(name) {
                this.modalDisPlay = false;
                //清空form规则检查
                this.$refs[name].resetFields();
            },
            pageChange(index) {
                this.initIconData(index);
            }
        },
        watch :{
            searchInput: function () {
                this.initIconData(1);
            }
        },
        created: function () {
            this.initIconData(1);
        }
    }
</script>

<style scoped>
    .layout {
        background: #fff;
        border-radius: 8px;
        padding: 5px 10px;
    }

    #search {
        text-align: center;
        margin: 20px;
    }

    #search-input {
        width: 20%;
    }

    #search-p {
        margin-top: 20px;
    }

    #icon-box {
        margin: 30px 50px;
        overflow:hidden;
    }

    .icon-item {
        width: 90px;
        border: 1px solid #808080;
        height: 90px;
        text-align: center;
        border-radius: 3px;
        overflow: hidden;
        padding-top: 20px;
        padding-bottom: 20px;
        cursor: pointer;
        float: left;
        margin: 10px;
        position: relative;
    }

        .icon-item:hover {
            box-shadow: 0px 0px 1px 1px #808080;
            transform: scale(1.1);
        }

    .icon-item-dele {
        position: absolute;
        right: 0px;
        top: 0px;
    }

        .icon-item-dele:hover {
            transform: scale(1.3);
        }

    #page-box {
        text-align: center;
        width:100%;
    }
</style>
